module.exports = __webpack_public_path__ + "static/img/2.389c3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/2.png
// module id = GM65
// module chunks = 0